import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { uid } from 'utils/uid';

export const BoardLoading: FC = () => {
  const rows = 2;
  const columns = 4;
  const coverHeight = 440;
  const coverWidth = 256;
  const padding = 8;
  const speed = 1;

  const coverHeightWithPadding = coverHeight + padding;
  const coverWidthWithPadding = coverWidth + padding;
  const initial = 35;
  const covers = Array(columns).fill(1);

  return (
    <ContentLoader
      style={{ padding: 'var(--spacing-03)' }}
      speed={speed}
      width={columns * coverWidthWithPadding}
      height={rows * coverHeightWithPadding}
    >
      <rect
        x="0"
        y="0"
        rx="0"
        ry="0"
        width={columns * coverWidthWithPadding - padding}
        height="20"
      />
      {covers.map((g, i) => {
        const vy = Math.floor(i / columns) * coverHeightWithPadding + initial;
        const vx =
          (i * coverWidthWithPadding) % (columns * coverWidthWithPadding);

        return (
          <rect
            key={uid(String(i))}
            x={vx}
            y={vy}
            rx="0"
            ry="0"
            width={coverWidth}
            height={coverHeight}
          />
        );
      })}
    </ContentLoader>
  );
};
